var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAkarFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 69.084,
    height: 85.605,
    viewBox: "0 0 69.084 85.605",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_akar-file",
    "data-name": "Icon akar-file",
    transform: "translate(-4.5 -1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_273",
    "data-name": "Path 273",
    d: "M6,11.26V77.344a8.26,8.26,0,0,0,8.26,8.26H63.823a8.26,8.26,0,0,0,8.26-8.26V29.194A8.26,8.26,0,0,0,69.6,23.288L51.259,5.354A8.26,8.26,0,0,0,45.485,3H14.26A8.26,8.26,0,0,0,6,11.26ZM26.651,48.433H51.433M26.651,64.954H39.042",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_274",
    "data-name": "Path 274",
    d: "M21,3V19.521a8.26,8.26,0,0,0,8.26,8.26H45.781",
    transform: "translate(26.302)",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAkarFile);
export default __webpack_public_path__ + "static/media/akar-file.8c7e7f54bcfb191d4c77d7851b89ba58.svg";
export { ForwardRef as ReactComponent };